import { GridTableBody, TableCellAttribute, UserTableConstructorInfo } from 'src/app/interfaces/tables.interfaces';
import { ColumnTypes } from 'src/app/views/grid-user-list/grid-table.enum';
import { PatientLink } from '../../relation-request.interface';
import { patientLinkRowData } from '../patient-link-table-factory';

export class PatientLinkTable {
  public buildTableData(items: PatientLink[]): UserTableConstructorInfo {
    return {
      header: this.getTableHeader(),
      body: this.getTableBody(items),
      attribute: this.getManageCellAttribute(),
    };
  }

  private getTableHeader(): ColumnTypes[] {
    return [ColumnTypes.USER, ColumnTypes.DISEASES, ColumnTypes.DATE, ColumnTypes.MANAGE];
  }

  private getManageCellAttribute(): TableCellAttribute {
    return { value_class_front: 'manageRelation', key: 'manage' };
  }

  private getTableBody(items: PatientLink[]): GridTableBody[] {
    return items.map(patientLinkRowData);
  }
}
